<template>
  <div class="policy-page">
    <section class="hero">
      <div class="container hero-grid">
        <div class="hero-copy">
          <p class="eyebrow">BAILYHANGA / Terms of Service</p>
          <h1>{{ texts.title }}</h1>
          <p class="lead">{{ texts.lead }}</p>
        </div>
        <div class="document-stamp" aria-label="Document information">
          <span>TERMS / 01</span>
          <strong>USE &amp; RESPONSIBILITY</strong>
          <small>PUBLIC DOCUMENT / 2026.08</small>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container card">
        <section class="policy-section">
          <h2>{{ texts.introTitle }}</h2>
          <p>{{ texts.introText1 }}</p>
          <p>{{ texts.introText2 }}</p>
          <p>{{ texts.introText3 }}</p>
        </section>

        <section class="policy-section">
          <h2>{{ texts.prohibitedTitle }}</h2>
          <ul>
            <li v-for="item in texts.prohibitedItems" :key="item">{{ item }}</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>{{ texts.accountTitle }}</h2>
          <ul>
            <li v-for="item in texts.accountItems" :key="item">{{ item }}</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>{{ texts.dataTitle }}</h2>
          <ul>
            <li v-for="item in texts.dataItems" :key="item">{{ item }}</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>{{ texts.remedyTitle }}</h2>
          <ul>
            <li v-for="item in texts.remedyItems" :key="item">{{ item }}</li>
          </ul>
        </section>

        <section class="policy-section">
          <h2>{{ texts.ipTitle }}</h2>
          <p>{{ texts.ipText1 }}</p>
          <p>{{ texts.ipText2 }}</p>
        </section>

        <section class="policy-section">
          <h2>{{ texts.liabilityTitle }}</h2>
          <p>{{ texts.liabilityText1 }}</p>
          <p>{{ texts.liabilityText2 }}</p>
        </section>

        <section class="policy-section">
          <h2>{{ texts.changeTitle }}</h2>
          <p>{{ texts.changeText }}</p>
        </section>

        <section class="policy-section">
          <h2>{{ texts.lawTitle }}</h2>
          <p>{{ texts.lawText1 }}</p>
          <p>{{ texts.lawText2 }}</p>
        </section>

        <div class="notice">
          <span class="notice-label">Service Contact</span>
          <strong>{{ texts.noticeLabel }}</strong>
          {{ texts.noticeText }}
        </div>

        <div class="actions">
          <router-link :to="{ name: 'spApiComplianceDetail' }" class="action-link">
            {{ texts.complianceLink }} <span>&rarr;</span>
          </router-link>
          <router-link :to="{ name: 'privacyDetail' }" class="action-link">
            {{ texts.privacyLink }} <span>&rarr;</span>
          </router-link>
          <a class="action-link primary" :href="contactHref">{{ texts.contactLink }} <span>&rarr;</span></a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { localeState } from "@/utils/locale";

export default {
  name: "UserTerms",
  data() {
    return {
      copy: {
        zh: {
          title: "用户协议",
          lead:
            "本协议适用于XINHE TRADING (HONGKONG) LIMITED提供的网站、软件及相关 SaaS 服务，尤其适用于亚马逊卖家、品牌所有者及其授权团队使用本平台进行运营管理、分析和协作的场景。",
          introTitle: "1. 协议说明与生效",
          introText1:
            "在注册、访问或使用本网站及相关服务前，请仔细阅读本协议。您点击同意、完成注册或继续使用服务，即表示您已理解并同意受本协议约束。",
          introText2:
            "如果您代表企业、团队或其他组织使用本服务，您声明并保证已获得充分授权，可代表该主体接受并履行本协议。",
          introText3:
            "本协议自您首次注册、登录或以其他方式使用本服务之日起生效。",
          prohibitedTitle: "2. 禁止行为",
          prohibitedItems: [
            "利用本服务从事违法违规、侵害他人权益、破坏系统安全或扰乱网络秩序的行为。",
            "通过本服务传播恶意代码、发起未授权访问、批量骚扰、垃圾信息投递或拒绝服务攻击等行为。",
            "伪造身份、误导平台、绕过权限控制，或非法访问、抓取、导出与您无权访问的数据。",
            "出售、转让、公开披露或跨客户聚合通过 Amazon SP-API 或本平台获取的数据。",
            "将本服务用于仿牌、侵权、欺诈、违规商品销售或其他违反平台规则和知识产权保护要求的活动。",
          ],
          accountTitle: "3. 账户与访问管理",
          accountItems: [
            "您应妥善保管账户、密码、验证码和其他认证信息，并对账户项下的一切操作负责。",
            "未经授权，您不得与他人共享账户，或允许他人以您的身份访问系统。",
            "如发现账户异常、泄露或未授权使用，应立即通知我们并及时采取安全措施。",
          ],
          dataTitle: "4. 数据使用与客户责任",
          dataItems: [
            "您应确保提交、同步或授权访问的数据来源合法，并有权授予我们为提供服务所需的处理权限。",
            "如涉及 Amazon SP-API 数据，您应遵守 Amazon 开发者协议、数据保护政策及相关平台规则。",
            "您不得要求我们将 Amazon 数据用于转售、公开分发、对外聚合展示或其他超出授权范围的用途。",
            "在客户支持过程中，如涉及个人信息或敏感数据，双方应仅在必要范围内共享并及时清理不再需要的数据。",
          ],
          remedyTitle: "5. 违约处理与救济",
          remedyItems: [
            "如我们合理判断您违反本协议、适用法律或平台规则，我们有权采取限制、暂停或终止服务等措施。",
            "在必要情况下，我们可要求您整改、删除违规内容、补充说明或配合安全调查。",
            "如因您的行为导致我们或第三方遭受损失，您应承担相应责任，并赔偿由此产生的合理损失和费用。",
          ],
          ipTitle: "6. 知识产权",
          ipText1:
            "本网站、软件、界面设计、商标、文案、代码和相关内容的知识产权归XINHE TRADING (HONGKONG) LIMITED或合法权利人所有。",
          ipText2:
            "未经书面许可，您不得复制、修改、反向工程、传播或以其他方式不当使用本服务及其相关内容。",
          liabilityTitle: "7. 责任限制",
          liabilityText1:
            "我们将在合理商业范围内持续提供服务，并努力保障系统安全、稳定和可用，但不对因网络故障、第三方原因、不可抗力或平台政策变化导致的服务中断承担无限责任。",
          liabilityText2:
            "在适用法律允许范围内，我们对间接损失、利润损失、业务中断或预期收益损失不承担责任。",
          changeTitle: "8. 协议更新",
          changeText:
            "我们有权根据法律法规、业务发展或合规要求更新本协议。更新后的版本将在网站公布后生效，您继续使用服务即视为接受更新内容。",
          lawTitle: "9. 适用法律与争议解决",
          lawText1:
            "本协议受中华人民共和国法律管辖；如适用场景涉及其他司法辖区的数据保护规则，我们也将结合相关合规要求进行处理。",
          lawText2:
            "因本协议引起或与本协议有关的争议，双方应先友好协商解决；协商不成的，可提交有管辖权的人民法院处理。",
          noticeLabel: "联系我们：",
          noticeText:
            "如果您对本协议有任何疑问，或需要就账户、授权与合规事项沟通，请联系 it_jch@xinhe.space。",
          complianceLink: "查看 SP-API 合规说明",
          privacyLink: "查看隐私政策",
          contactLink: "联系支持团队",
          contactSubject: "用户协议咨询",
        },
        en: {
          title: "Terms of Service",
          lead:
            "These terms apply to the website, software, and related SaaS services provided by XINHE TRADING (HONGKONG) LIMITED, especially where Amazon sellers, brand owners, and their authorized teams use the platform for operations management, analytics, and collaboration.",
          introTitle: "1. Agreement and Effective Date",
          introText1:
            "Please read these terms carefully before registering for, accessing, or using this website and related services. By clicking to agree, completing registration, or continuing to use the service, you acknowledge that you understand and accept these terms.",
          introText2:
            "If you use the service on behalf of a company, team, or other organization, you represent and warrant that you are fully authorized to bind that entity to these terms.",
          introText3:
            "These terms take effect on the date you first register, sign in, or otherwise use the service.",
          prohibitedTitle: "2. Prohibited Activities",
          prohibitedItems: [
            "Using the service for unlawful conduct, infringement, system abuse, security attacks, or disruption of network order.",
            "Using the service to distribute malicious code, perform unauthorized access, send spam, conduct bulk harassment, or launch denial-of-service attacks.",
            "Impersonating others, misleading the platform, bypassing access controls, or unlawfully accessing, scraping, or exporting data you are not authorized to access.",
            "Selling, transferring, publicly disclosing, or cross-customer aggregating data obtained through Amazon SP-API or this platform.",
            "Using the service for counterfeit goods, infringement, fraud, prohibited products, or other activities that violate platform rules or intellectual property protections.",
          ],
          accountTitle: "3. Account and Access Management",
          accountItems: [
            "You are responsible for safeguarding your account, password, verification codes, and other authentication information, and for all activities under your account.",
            "You may not share your account with others or allow others to access the system under your identity without authorization.",
            "If you discover suspicious activity, credential leakage, or unauthorized use, you must notify us promptly and take appropriate security measures.",
          ],
          dataTitle: "4. Data Usage and Customer Responsibilities",
          dataItems: [
            "You must ensure that any data submitted, synchronized, or authorized for access is lawfully obtained and that you have the right to grant us the permissions necessary to provide the service.",
            "If Amazon SP-API data is involved, you must comply with the Amazon developer agreement, data protection requirements, and related platform policies.",
            "You may not require us to use Amazon data for resale, public distribution, public aggregation, or any purpose outside the authorized scope.",
            "Where personal or sensitive information is involved during customer support, both parties must share only what is necessary and promptly remove data that is no longer needed.",
          ],
          remedyTitle: "5. Enforcement and Remedies",
          remedyItems: [
            "If we reasonably determine that you have violated these terms, applicable law, or platform rules, we may restrict, suspend, or terminate the service.",
            "Where necessary, we may require remediation, deletion of non-compliant content, supplemental explanations, or cooperation with security investigations.",
            "If your conduct causes loss to us or to third parties, you are responsible for the resulting liabilities and for reasonable related costs and damages.",
          ],
          ipTitle: "6. Intellectual Property",
          ipText1:
            "The intellectual property rights in this website, software, interface design, trademarks, copy, code, and related content belong to XINHE TRADING (HONGKONG) LIMITED or the relevant lawful rights holders.",
          ipText2:
            "Without written permission, you may not copy, modify, reverse engineer, distribute, or otherwise misuse the service or its related content.",
          liabilityTitle: "7. Limitation of Liability",
          liabilityText1:
            "We will make commercially reasonable efforts to provide a secure, stable, and available service, but we do not assume unlimited liability for interruptions caused by network failures, third parties, force majeure, or platform policy changes.",
          liabilityText2:
            "To the extent permitted by applicable law, we are not liable for indirect damages, lost profits, business interruption, or loss of expected revenue.",
          changeTitle: "8. Updates to These Terms",
          changeText:
            "We may update these terms based on legal, regulatory, business, or compliance changes. The updated version becomes effective when published on the website, and your continued use of the service constitutes acceptance of the update.",
          lawTitle: "9. Governing Law and Dispute Resolution",
          lawText1:
            "These terms are governed by the laws of the People's Republic of China. Where specific scenarios involve additional data protection requirements in other jurisdictions, we will also address those compliance obligations as applicable.",
          lawText2:
            "Any dispute arising out of or related to these terms should first be resolved through friendly consultation. If consultation fails, the dispute may be submitted to a court with proper jurisdiction.",
          noticeLabel: "Contact:",
          noticeText:
            "If you have any questions about these terms, or need to discuss account, authorization, or compliance matters, please contact it_jch@xinhe.space.",
          complianceLink: "View SP-API Compliance Statement",
          privacyLink: "View Privacy Policy",
          contactLink: "Contact Support Team",
          contactSubject: "Terms of service inquiry",
        },
      },
    };
  },
  computed: {
    locale() {
      return localeState.locale;
    },
    texts() {
      return this.copy[this.locale] || this.copy.zh;
    },
    contactHref() {
      return `mailto:it_jch@xinhe.space?subject=${encodeURIComponent(
        this.texts.contactSubject
      )}`;
    },
  },
};
</script>

<style>
.policy-page {
  --ink: #122620;
  --paper: #f5f2e9;
  --accent: #456d61;
  --line: rgba(18, 38, 32, 0.16);
  background: var(--paper);
  color: var(--ink);
  padding-bottom: 0;
}
.hero {
  background: #d9d3c5;
  color: var(--ink);
  padding: 5rem 0;
}
.container {
  box-sizing: border-box;
  max-width: 80rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.hero-grid {
  align-items: end;
  display: grid;
  gap: 3rem;
}
.hero-copy { text-align: left; }
.eyebrow {
  color: var(--accent);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  margin: 0 0 1.4rem;
  opacity: 1;
}
h1 {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 3rem;
  font-weight: 400;
  line-height: 1.08;
}
.lead {
  color: rgba(18, 38, 32, 0.66);
  font-size: 0.96rem;
  line-height: 1.85;
  margin: 1.5rem 0 0;
  max-width: 48rem;
}
.document-stamp {
  border-left: 3px solid var(--accent);
  padding: 0.75rem 0 0.75rem 1.25rem;
  text-align: left;
}
.document-stamp span,
.document-stamp small {
  color: rgba(18, 38, 32, 0.48);
  display: block;
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 0.64rem;
  letter-spacing: 0.1em;
}
.document-stamp strong {
  color: var(--ink);
  display: block;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.25;
  margin: 0.7rem 0;
}
.content { padding: 0; }
.card {
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  margin-top: 0;
  padding: 0;
}
.policy-section {
  border-bottom: 1px solid var(--line);
  display: grid;
  gap: 1.25rem;
  padding: 3.5rem 0;
}
.policy-section + .policy-section { margin-top: 0; }
.policy-section h2 {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.2;
  margin: 0;
}
.policy-section p,
.policy-section li {
  color: rgba(18, 38, 32, 0.67);
  font-size: 0.9rem;
  line-height: 1.85;
  margin-bottom: 0;
}
.policy-section p { margin-top: 0; }
.policy-section p + p { margin-top: 1rem; }
.policy-section ul {
  border-top: 1px solid var(--line);
  list-style: none;
  margin: 0;
  padding: 0;
}
.policy-section li {
  border-bottom: 1px solid var(--line);
  padding: 0.9rem 0 0.9rem 1.25rem;
  position: relative;
}
.policy-section li::before {
  background: var(--accent);
  content: "";
  height: 5px;
  left: 0;
  position: absolute;
  top: 1.7rem;
  width: 5px;
}
.policy-page .policy-section:nth-of-type(4) {
  background: var(--ink);
  box-sizing: border-box;
  margin-left: 0;
  margin-right: 0;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.policy-page .policy-section:nth-of-type(4) h2 { color: #f7f3e8; }
.policy-page .policy-section:nth-of-type(4) ul { border-color: rgba(247, 243, 232, 0.18); }
.policy-page .policy-section:nth-of-type(4) li {
  border-color: rgba(247, 243, 232, 0.18);
  color: rgba(247, 243, 232, 0.68);
}
.notice {
  background: #d9d3c5;
  border: 0;
  border-radius: 0;
  color: rgba(18, 38, 32, 0.7);
  line-height: 1.8;
  margin: 0;
  padding: 3.5rem 1.25rem;
}
.notice-label {
  color: var(--accent);
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  margin-bottom: 1rem;
  text-transform: uppercase;
}
.notice strong {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1.6rem;
  font-weight: 400;
}
.actions {
  display: grid;
  gap: 0;
  margin: 0;
  padding: 1.5rem 0 5rem;
}
.action-link {
  align-items: center;
  border: 0;
  border-bottom: 1px solid var(--line);
  border-radius: 0;
  color: var(--ink);
  display: flex;
  font-size: 0.82rem;
  justify-content: space-between;
  padding: 1rem 0;
}
.action-link.primary {
  background: var(--ink);
  color: #f7f3e8;
  margin-top: 1rem;
  padding: 1rem;
}
@media (min-width: 1024px) {
  .hero { padding: 7rem 0 6rem; }
  .hero-grid { grid-template-columns: 1.45fr 0.55fr; gap: 6rem; }
  h1 { font-size: 4.25rem; }
  .policy-section {
    gap: 4rem;
    grid-template-columns: 0.7fr 1.3fr;
    padding: 5rem 0;
  }
  .policy-section h2 { font-size: 2.6rem; }
  .policy-section > p,
  .policy-section > ul { grid-column: 2; }
  .policy-section > h2 + p,
  .policy-section > h2 + ul { grid-row: 1; }
  .policy-section > p + p { grid-column: 2; margin-top: -2rem; }
  .policy-page .policy-section:nth-of-type(4) {
    margin-left: calc((80rem - 100vw) / 2);
    margin-right: calc((80rem - 100vw) / 2);
    padding-left: max(1.25rem, calc((100vw - 80rem) / 2));
    padding-right: max(1.25rem, calc((100vw - 80rem) / 2));
  }
  .notice { margin-left: calc((80rem - 100vw) / 2); margin-right: calc((80rem - 100vw) / 2); padding: 5rem max(1.25rem, calc((100vw - 80rem) / 2)); }
  .actions { grid-template-columns: repeat(3, 1fr); padding-bottom: 6rem; }
  .action-link { border-right: 1px solid var(--line); padding: 1.2rem; }
  .action-link.primary { margin-top: 0; }
}
@media (max-width: 560px) {
  .hero { padding: 4rem 0; }
  h1 { font-size: 2.5rem; }
  .policy-section h2 { font-size: 1.8rem; }
  .document-stamp strong { font-size: 1.3rem; overflow-wrap: anywhere; }
}

</style>
